import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { ProductCardSkeletonComponent, ProductSliderSkeletonComponent } from '@libs/shop/components';
import { ProductContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../../content-base.component';

@Component({
  selector: 'ui-product-content-skeleton',
  templateUrl: './product-content-skeleton.component.html',
  styleUrl: './product-content-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductSliderSkeletonComponent,
    ProductCardSkeletonComponent,
  ],
})
export class ProductContentSkeletonComponent extends ContentBaseComponent<ProductContentModel> {
  public cardViewClass: Signal<string> = computed(() => {
    return this.data().cardView + '-view';
  });

  public readonly skeletonArray: number[] = new Array<number>(8).fill(0);
}
